import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaxTemperatureService } from './max-temperature.service';
import { MeanTemperatureService } from './mean-temperature.service';
import { MinTemperatureService } from './min-temperature.service';
import { PopulationDensityService } from './population-density.service';
import { PrecipitationService } from './precipitation.service';
import { SeaLevelRiseService } from './sea-level-rise.service';
import { SurfaceWindService } from './surface-wind.service';
import { SnowfallService } from './snowfall.service';
import { ClimateOverlayPermission, DatapointsClimateChartService } from './datapoints-climate-chart.service';
import { SeaLevelRiseWarmingService } from './sea-level-rise-warming.service';
import { Spi6Service } from './spi6.service';
import { Spi6ScoreService } from './spi6-score.service';
import { Spi6ChangeService } from './spi6-change.service';
import { CoolingDegreeDaysService } from './cooling-degree-days.service';
import { CoolingDegreeDaysScoreService } from './cooling-degree-days-score.service';
import { CoolingDegreeDaysChangeService } from './cooling-degree-days-change.service';
import { TxxService } from './txx.service';
import { TxxScoreService } from './txx-score.service';
import { TxxChangeService } from './txx-change.service';
import { ClimateTService } from './climate-t.service';
import { ClimateTScoreService } from './climate-t-score.service';
import { ClimateTChangeService } from './climate-t-change.service';
import { FrostDaysService } from './frost-days.service';
import { FrostDaysScoreService } from './frost-days-score.service';
import { FrostDaysChangeService } from './frost-days-change.service';
import { HeatingDegreeDaysService } from './heating-degree-days.service';
import { HeatingDegreeDaysScoreService } from './heating-degree-days-score.service';
import { HeatingDegreeDaysChangeService } from './heating-degree-days-change.service';
import { ExtremeHotDaysService } from './extreme-hot-days.service';
import { ExtremeHotDaysScoreService } from './extreme-hot-days-score.service';
import { ExtremeHotDaysChangeService } from './extreme-hot-days-change.service';
import { VeryExtremeHotDaysService } from './very-extreme-hot-days.service';
import { VeryExtremeHotDaysScoreService } from './very-extreme-hot-days-score.service';
import { VeryExtremeHotDaysChangeService } from './very-extreme-hot-days-change.service';
import { ClimatePrService } from './climate-pr.service';
import { ClimatePrScoreService } from './climate-pr-score.service';
import { ClimatePrChangeService } from './climate-pr-change.service';
import { ClimateCddService } from './climate-cdd.service';
import { ClimateCddScoreService } from './climate-cdd-score.service';
import { ClimateCddChangeService } from './climate-cdd-change.service';
import { ClimateRx1dayService } from './climate-rx1day.service';
import { ClimateRx1dayScoreService } from './climate-rx1day-score.service';
import { ClimateRx1dayChangeService } from './climate-rx1day-change.service';
import { ClimateRx5dayService } from './climate-rx5day.service';
import { ClimateRx5dayScoreService } from './climate-rx5day-score.service';
import { ClimateRx5dayChangeService } from './climate-rx5day-change.service';
import { ClimatePrsnService } from './climate-prsn.service';
import { ClimatePrsnScoreService } from './climate-prsn-score.service';
import { ClimatePrsnChangeService } from './climate-prsn-change.service';
import { ClimateSstService } from './climate-sst.service';
import { ClimateSstScoreService } from './climate-sst-score.service';
import { ClimateSstChangeService } from './climate-sst-change.service';
import { ClimateSfcWindService } from './climate-sfcwind.service';
import { ClimateSfcWindScoreService } from './climate-sfcwind-score.service';
import { ClimateSfcWindChangeService } from './climate-sfcwind-change.service';
import { ConsolidatedRiskScoreChartService } from './consolidated-risk-score-chart.service';
import { ClimateTrService } from './climate-tr.service';
import { ClimateTrScoreService } from './climate-tr-score.service';
import { ClimateTrChangeService } from './climate-tr-change.service';
import { ClimateSlrService } from './climate-slr.service';
import { ClimateSlrScoreService } from './climate-slr-score.service';
import { ClimateSlrChangeService } from './climate-slr-change.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    ClimateOverlayPermission,
    DatapointsClimateChartService,
    MaxTemperatureService,
    MeanTemperatureService,
    MinTemperatureService,
    PopulationDensityService,
    PrecipitationService,
    SeaLevelRiseService,
    SnowfallService,
    SurfaceWindService,
    SeaLevelRiseWarmingService,
    Spi6Service,
    Spi6ScoreService,
    Spi6ChangeService,
    CoolingDegreeDaysService,
    CoolingDegreeDaysScoreService,
    CoolingDegreeDaysChangeService,
    TxxService,
    TxxScoreService,
    TxxChangeService,
    ClimateTService,
    ClimateTScoreService,
    ClimateTChangeService,
    FrostDaysService,
    FrostDaysScoreService,
    FrostDaysChangeService,
    HeatingDegreeDaysService,
    HeatingDegreeDaysScoreService,
    HeatingDegreeDaysChangeService,
    ExtremeHotDaysService,
    ExtremeHotDaysScoreService,
    ExtremeHotDaysChangeService,
    VeryExtremeHotDaysService,
    VeryExtremeHotDaysScoreService,
    VeryExtremeHotDaysChangeService,
    ClimatePrService,
    ClimatePrScoreService,
    ClimatePrChangeService,
    ClimateCddService,
    ClimateCddScoreService,
    ClimateCddChangeService,
    ClimateRx1dayService,
    ClimateRx1dayScoreService,
    ClimateRx1dayChangeService,
    ClimateRx5dayService,
    ClimateRx5dayScoreService,
    ClimateRx5dayChangeService,
    ClimatePrsnService,
    ClimatePrsnScoreService,
    ClimatePrsnChangeService,
    ClimateSstService,
    ClimateSstScoreService,
    ClimateSstChangeService,
    ClimateSfcWindService,
    ClimateSfcWindScoreService,
    ClimateSfcWindChangeService,
    ConsolidatedRiskScoreChartService,
    ClimateTrService,
    ClimateTrScoreService,
    ClimateTrChangeService,
    ClimateSlrService,
    ClimateSlrScoreService,
    ClimateSlrChangeService,
    ConsolidatedRiskScoreChartService
  ]
})
export class ClimateModule { }
